<div class="cg-flex-vertical-center">
  <div class="flag-block">
    <cigna-flag
      size="medium"
      [disabled]="!isEditable"
      [flagged]="flaggedKeys.includes(claim.claimSummary.claimReferenceNumber)"
      (change)="flagClick($event, claim)"
    ></cigna-flag>
  </div>

  <div class="name-block divider-right">
    <div class="cg-margin-bottom-sm">
      <a
        *ngIf="!isRestrictedImpersonator"
        class="cg-font-size-m"
        data-test="recent-claim-link"
        [routerLink]="[routeDetails.url]"
        [queryParams]="routeDetails.queryParams"
        [state]="routeDetails.state"
        [cignaTrackClicks]="[
          'trackEventOther',
          'Claims',
          'ac-DB005-Claims Click',
          {
            prop20: isFlagView ? 'Flagged' : 'Recent',
            events: isFlagView ? 'event436' : 'event435'
          }
        ]"
      >
        <strong>
          {{ claim.member.memberFirstName }} {{ claim.member.memberLastName }}
        </strong>
      </a>
      <strong *ngIf="isRestrictedImpersonator">
        {{ claim.member.memberFirstName }} {{ claim.member.memberLastName }}
      </strong>
    </div>
    <div class="secondary-text cg-font-size-xs">
      {{ 'dashboard.dashboardComponent.patientId' | translate }}
    </div>
    <div>
      <!-- For Facets sometimes member Id is not available so need to construct it from memberSearchKey-->
      {{
        !isRestrictedImpersonator
          ? claim.member.memberId ||
            (claim.member.memberSearchKey?.split(':'))[0]
          : '--'
      }}
    </div>
  </div>

  <div class="cg-flex-column">
    <div class="cg-margin-bottom-md cg-flex">
      <cigna-claim-status
        size="small"
        [status]="mapInboundClaimStatus(claim.claimSummary.claimStatus)"
      ></cigna-claim-status>
      <div *ngIf="isFlagView" class="date-flagged-block">
        <div class="cg-font-size-xs">
          {{ 'dashboard.dateFlagged' | translate }} {{ claim.dateFlagged }}
        </div>
      </div>
    </div>

    <div class="detail-block">
      <div class="cg-margin-right-sm">
        <div class="secondary-text cg-font-size-xs">
          {{ 'dashboard.dashboardComponent.claimReference' | translate }}
        </div>
        <div>
          {{
            !isRestrictedImpersonator
              ? claim.claimSummary.claimReferenceNumber
              : '--'
          }}
        </div>
      </div>

      <div class="cg-margin-right-sm">
        <div class="secondary-text cg-font-size-xs">
          {{ 'dashboard.dashboardComponent.submittedAmount' | translate }}
        </div>
        <div>
          {{
            !isRestrictedImpersonator ? claim.claimSummary.chargeAmount : '--'
          }}
        </div>
      </div>

      <div>
        <div class="secondary-text cg-font-size-xs">
          {{ 'dashboard.dashboardComponent.dos' | translate }}:
        </div>
        <div>{{ claim.claimSummary.dateOfService }}</div>
      </div>
    </div>
  </div>
</div>
